/** Service workers are optional; browser policy can also make the getter throw. */
export const getServiceWorker = (): ServiceWorkerContainer | undefined => {
  try {
    if (typeof navigator === "undefined") return undefined;
    // eslint-disable-next-line no-restricted-properties -- Single guarded access boundary for this optional browser API.
    return navigator.serviceWorker ?? undefined;
  } catch {
    return undefined;
  }
};

export const supportsPushNotifications = (): boolean =>
  typeof window !== "undefined" &&
  !!getServiceWorker() &&
  "Notification" in window &&
  "PushManager" in window;
